/* global u */
import debounce from '../../../00-base/global/utils/debounce';

/**
 * Fix orphaned lines after a floated wysiwyg-embedded image.
 */
export default function() {

  /**
   * Change alignment of paragraph after a floated element if num. lines below the float < ~2.
   */
  function fixFloatOrphans() {
    const $floats = u('.js-embed-align');
    $floats.each(function(embed) {

      // Get the heights of the embed and next element.
      const embed_height = embed.offsetHeight + 20;
      const next_el = embed.nextElementSibling;

      if (next_el) {
        const height_diff = next_el.offsetHeight - embed_height;

        // Consider it 'orphaned' if height diff with the floated embed is <= 45px (~2 lines).
        const is_orphan = height_diff <= 60;
        next_el.style.overflow = is_orphan ? 'hidden' : 'inherit';
      }
    });
  }

  fixFloatOrphans();

  window.addEventListener('resize', () => {
    debounce(fixFloatOrphans(), 100);
  });
}

